<template>
  <unicom-linha :espacamento="false">
    <unicom-coluna sm="12" style="padding-bottom: 24px">
      <div class="titulo negrito cor-fonte fonte-primaria">
        Solicitação: <span class="cor-principal"> Exclusão </span>
      </div>
      <div class="medio segunda-cor-fonte" style="padding-top: 12px">
        Uma solicitação de exclusão foi identificada. Para concluir, anexe um
        zip contendo as justificativas.
      </div>
    </unicom-coluna>
    <unicom-coluna
      sm="12"
      :md="listaArquivos.length !== 0 ? 5 : 12"
      style="padding-right: 32px"
    >
      <transition name="importador">
        <Importador
          class="importador"
          v-if="mostrarImportador"
          @arquivo="salvarArquivo"
        />
      </transition>
    </unicom-coluna>
    <unicom-coluna
      class="lista-arquivos"
      :class="{ aberto: mostrarImportador }"
      sm="12"
      :md="mostrarImportador ? 7 : 12"
    >
      <ListaArquivos
        :listaArquivos="listaArquivos"
        @baixar-arquivo="uuid => $emit('baixar-arquivo', uuid)"
      />
    </unicom-coluna>
    <div
      class="arquivo-vazio"
      v-if="!podeEnviarArquivo && listaArquivos.length <= 0"
    >
      <div class="mb-2">
        <unicom-icone
          :especuraDoIcone="1.5"
          style="color: #9e9e9e"
          nome="file-text"
          :tamanho="64"
        />
      </div>
      <div class="subtitulo mb-1">Nenhum arquivo encontrado.</div>
    </div>
  </unicom-linha>
</template>

<script>
import Importador from "./Importador/Importador";
import ListaArquivos from "../ListaArquivos/ListaArquivos";
import { TIPOS_ARQUIVOS } from "../ListaArquivos/TiposArquivos/TiposArquivosEnum";

export default {
  components: {
    Importador,
    ListaArquivos
  },
  props: {
    listaArquivos: {
      type: Array,
      default: () => {
        return [
          // {
          //   "arquivo": "string",
          //   "baixavel": true,
          //   "dtAlteracao": "string",
          //   "dtUpload": "string",
          //   "id": 0,
          //   "status": {
          //     "chave": "PROCESSANDO",
          //     "descricao": "string"
          //   },
          //   "usuarioAlteracao": {
          //     "id": 0,
          //     "nome": "string"
          //   },
          //   "usuarioUpload": {
          //     "id": 0,
          //     "nome": "string"
          //   },
          //   "uuid": "string"
          // }
        ];
      }
    },
    podeEnviarArquivo: {
      type: Boolean
    },
    exibeAbaDeExclusao: {
      type: Boolean
    },
    codigoUnimed: {
      type: [String, Number]
    }
  },
  methods: {
    /**
     * @param { File } arquivo
     */
    salvarArquivo(arquivo) {
      const { name, size } = arquivo;

      const objetoArquivoUpload = this.criarObjetoArquivo(
        name,
        size,
        TIPOS_ARQUIVOS.UPLOAD
      );

      let formData = new FormData();
      formData.append("uploadJustificativa", arquivo);

      this.$emit("upload-arquivo", { formData, objetoArquivoUpload });
    },

    criarObjetoArquivo(nome, tamanho, tipo) {
      return {
        tipoArquivo: tipo,
        objetoArquivo: {
          nomeArquivo: nome,
          tamanhoArquivo: this.formatarBytes(tamanho),
          barraProgresso: 0,
          id: 1
        }
      };
    }
  },
  computed: {
    mostrarArquivoRecebido() {
      return this.listaArquivos.some(e => {
        return e.tipoArquivo === TIPOS_ARQUIVOS.ANALISE;
      });
    },
    mostrarImportador() {
      const statusPrestador = document.querySelector("#status-prestador > div")
        .innerText;

      if (statusPrestador === "Pendente") {
        return true;
      }

      if (!this.podeEnviarArquivo) return false;

      const verificaTipoArquivo = tipo =>
        this.listaArquivos.some(e => e.tipoArquivo === tipo);

      if (
        verificaTipoArquivo(TIPOS_ARQUIVOS.APROVADO) ||
        verificaTipoArquivo(TIPOS_ARQUIVOS.UPLOAD)
      ) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.arquivo-vazio {
  background: #f1f2f1;
  margin: 0;
  height: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

.importador {
  transition: all 0.3s ease-in-out;
}

.lista-arquivos {
  transition: all 0.3s ease-in-out;
  margin-left: auto;

  &.aberto {
    transition: none;
  }
}

// ANIMAÇÃO IMPORTADOR

.importador-enter,
.importador-leave-to {
  opacity: 0;
}

.importador-enter {
  transform: translateX(-90%);
}

.importador-leave-to {
  transform: translateX(-110%);
  transition: all 0.2s ease-in-out;
}

.importador-leave-active {
  position: absolute;
}
</style>
